module.exports = new function playGames () {

    var closeLb = $('.close-lb');
    var playbtn = $('.js-play-game');
    var gameIframe = $('.game-iframe');
    var lightBox = $('.game-lightbox');
    var fullscreen = $('.fullscreen-game');

    var gamePromoMenu = function(callback) {
        var gamePromoMenu = $('.game-promotion-tools');
        var gameButtons = $('.game-promo-button');
        var defaultButton = 'game-promo-button--default';

        gamePromoMenu.addClass('show');

        gameButtons.unbind().on('click', function(callback) {
            var iframeSource = this.dataset.iframeUrl + '&lang=en';
            showGame(iframeSource);
        });
    }

    var toggleLightbox = function (e) {

        if ( e.target.className == 'close-lb' ) {
            gameIframe.removeClass('game-iframe_show');
            gameIframe.children().remove();
            gameIframe.removeClass('game-iframe_fullscreen');
            gameIframe.removeClass('game-iframe_ratio169');
            $('.game-promotion-tools').removeClass('show');
            $('.game-promotion-tools').fadeIn(50);

            setTimeout(function() {
                lightBox.toggleClass('game-lightbox_show');
            }, 400);
        }
        else {
            var btnData = $(this).data('iframe');
            var gameRatio = $(this).data('ratio');
            lightBox.toggleClass('game-lightbox_show');
            setTimeout(function() {
                $(e.currentTarget).hasClass('promotion-buttons') ? gamePromoMenu() : showGame(btnData, gameRatio);
                // showGame(btnData, gameRatio);
            }, 400);

        }

    }

    var showGame = function (src, ratio) {
        $('.game-promotion-tools').fadeOut(50);
        var iframe = $('<iframe frameBorder="0">').prop('src', src);
            gameIframe.addClass('game-iframe_show');
            gameIframe.addClass('game-iframe_ratio169');
            iframe.appendTo(gameIframe);
    };

    $('.back-fullscreen').on('click', function () {
        var gameIframe = $('.game-iframe iframe');
        gameIframe.fadeOut(10);
        gameIframe.removeClass('fullscreen');
        gameIframe.remove();
        $('.game-promotion-tools').fadeIn(50);
    });

    var gameFullscreen = function () {
        gameIframe.addClass('game-iframe_fullscreen');
    };

    $(document).keyup(function(e) {

        if ( e.keyCode === 27 ) {
            $('.game-promotion-tools').removeClass('show');
            $('.game-promotion-tools').fadeIn(50);
            gameIframe.removeClass('game-iframe_show');
            gameIframe.removeClass('game-iframe_ratio169');
            gameIframe.children().remove();
            gameIframe.removeClass('game-iframe_fullscreen');
            setTimeout(function() {
                lightBox.removeClass('game-lightbox_show');
            }, 400);
        }

    });

    playbtn.on('click', toggleLightbox);
    closeLb.on('click', toggleLightbox);
    fullscreen.on('click', gameFullscreen);

};
